import Editor from "../../../pages/sop/editor";
import Footer from "../../Landing/Footer";
import CategoryCheck from "../categoryCheck";
// import GenerationModal from "../GenerationModal";
import { useAsyncEffect } from "rooks";

import CategorySidebar from "../GenerationUI/CategorySidebar";
import PlagiarismModal from "../Plagiarism/index";
import { useEffect, useState } from "react";
import { PlusCircleIcon } from "@heroicons/react/24/outline";
import { useDispatch, useSelector } from "react-redux";
import { setSopTitle } from "../../../store/sop/actions";
import { setSidebarOpen } from "../../../store/sop/actions";
import { setSoptitle } from "../../../apiFunctions/sop/utils";
import { useRouter } from "next/router";
import { getCredits, getUser } from "../../../apiFunctions/user";

import PremiumModal from "../../generic/PurchaseCreditModal";

export interface SOPPageComponentProps {}

const SOPPageComponent: React.FC<SOPPageComponentProps> = ({}) => {
  const dispatch = useDispatch();
  const [Credits, setCredits] = useState();
  const [open, setOpen] = useState(false);
  const sop_title = useSelector((state: any) => state.sop.sop_title);
  const router = useRouter();
  const { sopId, type } = router.query;

  const [editTitle, setEditTitle] = useState(false);
  const [Title, setTitle] = useState(sop_title);

  useEffect(() => {
    if (Credits == 0) {
      setOpen(true);
    }
  }, [Credits]);
  useAsyncEffect(async () => {
    try {
      const credits: any = await getCredits();
      setCredits(credits?.sop_credits);
    } catch (e: any) {}
  }, []);
  return (
    <main className="bg-tootler-primary-50 md:max-w-[1440px] max-w-xl mx-auto md:px-8 ">
      <PremiumModal open={open} setOpen={setOpen} />
      <CategorySidebar setpurchaseModal={setOpen} />
      <PlagiarismModal />

      <div className=" pt-3 rounded-2xl flex">
        <div className=" flex w-full">
          <div className="hidden md:block md:basis-1/3 lg:basis-1/4 ">
            <CategoryCheck setpurchaseModal={setOpen}></CategoryCheck>
          </div>
          <div className="relative w-full md:basis-2/3 lg:basis-3/4">
            <Editor />
            {/*  <button
              type="button"
              className="md:hidden sticky bottom-8 left-5 flex gap-3 items-center rounded-md hover:text-gray-900 focus:outline-none bg-primary-500 text-white px-3 text-sm font-medium
              focus:ring-2 focus:ring-inset focus:ring-primary-500"
              onClick={() => dispatch(setSidebarOpen(true))}
            >
              <PlusCircleIcon className="h-10 w-10 pr-2 border-r-2" />

              <p className="py-4">Add Section</p>
            </button>*/}
          </div>
        </div>
      </div>
    </main>
  );
};

export default SOPPageComponent;
